import { useEffect, useState } from "react";
import type { HealthResponse } from "@strength-assess/shared";

type ApiStatus =
  | { state: "loading" }
  | { state: "ok"; data: HealthResponse }
  | { state: "error"; message: string };

export function App() {
  const [status, setStatus] = useState<ApiStatus>({ state: "loading" });

  useEffect(() => {
    const apiBase = import.meta.env.VITE_API_URL || "";
    fetch(`${apiBase}/api/health`)
      .then(async (r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return (await r.json()) as HealthResponse;
      })
      .then((data) => setStatus({ state: "ok", data }))
      .catch((err) => setStatus({ state: "error", message: String(err) }));
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-md w-full text-center">
        <div className="font-display text-[11px] tracking-[4px] text-venetian mb-3">
          STRENGTH STUDIO
        </div>
        <h1 className="font-display text-3xl tracking-[2px] text-ironstone leading-tight">
          ASSESS
        </h1>
        <p className="font-serif italic text-lg text-flint mt-4">
          Coming soon.
        </p>

        <div className="mt-12 pt-8 border-t border-border">
          <div className="text-[10px] tracking-[2px] uppercase text-flint font-semibold mb-3">
            System status
          </div>
          <ApiStatusBadge status={status} />
        </div>

        <p className="text-xs text-flint mt-16">
          Internal tool · Staff use only
        </p>
      </div>
    </div>
  );
}

function ApiStatusBadge({ status }: { status: ApiStatus }) {
  if (status.state === "loading") {
    return (
      <div className="inline-flex items-center gap-2 text-sm text-flint">
        <span className="w-2 h-2 rounded-full bg-flint animate-pulse" />
        Checking API…
      </div>
    );
  }
  if (status.state === "error") {
    return (
      <div className="inline-flex items-center gap-2 text-sm text-venetian">
        <span className="w-2 h-2 rounded-full bg-venetian" />
        API unreachable
      </div>
    );
  }
  return (
    <div className="inline-flex items-center gap-2 text-sm text-basalt">
      <span className="w-2 h-2 rounded-full bg-basalt" />
      API v{status.data.version} · online
    </div>
  );
}
